import {
	TextField,
	DialogTitle,
	DialogContent,
	Dialog,
	Button,
	DialogActions,
	Typography,
	CircularProgress,
} from '@mui/material';
import { FC, useState } from 'react';
import { addShopFailure, addShopRequest } from 'redux/reducers/shops/reducer';
import { useDispatch, useSelector } from 'react-redux';
import {
	getShopAddError,
	getShopAddIsLoad,
	getShopAttributesForm,
	getShopAttributesFormIsLoad,
} from 'redux/reducers/shops/selectors';
import { AddShop } from './AddShop';
import { MapFields } from './MapFields';

export const AddShopDialog: FC<{
	open: boolean;
	onClose: () => void;
}> = ({ open, onClose }) => {
	const dispatch = useDispatch();
	const [step, setStep] = useState(1);
	const shopAttributesForm = useSelector(getShopAttributesForm);
	const shopAddError = useSelector(getShopAddError);
	const shopAddIsLoad = useSelector(getShopAddIsLoad);
	const shopAttributesFormIsLoad = useSelector(getShopAttributesFormIsLoad);

	const handleClose = () => {
		setStep(1);
		dispatch(addShopFailure(null));
		onClose();
	};

	return (
		<Dialog open={open} fullWidth maxWidth="sm">
			{step === 1 && <AddShop open={open} onClose={onClose} setStep={setStep} />}
			{step === 2 &&
				shopAttributesForm?.shopId &&
				!shopAddError &&
				!shopAddIsLoad &&
				!shopAttributesFormIsLoad && (
					<MapFields
						open={open}
						onClose={onClose}
						setStep={setStep}
						shopId={shopAttributesForm.shopId}
					/>
				)}
			{(shopAddIsLoad || shopAttributesFormIsLoad) && (
				<>
					<DialogTitle>Loading...</DialogTitle>
					<DialogContent>
						<CircularProgress />
					</DialogContent>
				</>
			)}
			{shopAddError && (
				<>
					<DialogTitle sx={{ color: 'error.main' }}>Something went wrong</DialogTitle>
					<DialogContent>
						<Typography variant="body1" color="error">
							{shopAddError}
						</Typography>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose} size="small" variant="contained" color="primary">
							Close
						</Button>
					</DialogActions>
				</>
			)}
		</Dialog>
	);
};
